import { IPillProps } from '@qapline/ui';

import { TCommissionState, TCustomerCommissionState } from '../schemas';

export const COMMISSION_STATE_TO_PILL_COLOR: Record<TCommissionState, IPillProps['color']> = {
    ENQUIRY_FROM_WEBSITE: 'sky',
    ENQUIRY_FROM_CUSTOMER_ZONE: 'sky',
    CREATED: 'sky',
    ACCEPTED: 'primary',
    WAITING_FOR_OFFERS: 'warning',
    WAITING_FOR_PRICE_APPROVAL: 'warning',
    WAITING_FOR_OFFERS_FOR_CUSTOMER: 'warning',
    WAITING_FOR_CUSTOMER_APPROVAL: 'warning',
    CARRIER_ASSIGNED: 'warning',
    ORDER_SENT: 'warning',
    IN_PROGRESS: 'primary',
    COMPLETED: 'success',
    IN_CLAIM: 'warning',
    CANCELLED: 'error',
    CANCELLATION_APPROVAL: 'error',
    CANCELLED_WITH_FAILED_ATTEMPT: 'error',
};

export const CUSTOMER_COMMISSION_STATE_TO_PILL_COLOR: Record<TCustomerCommissionState, IPillProps['color']> = {
    ENQUIRY: 'gray',
    PROCESSING: 'sky',
    WAITING_FOR_OFFERS: 'warning',
    WAITING_FOR_APPROVAL: 'warning',
    VEHICLE_ASSIGNED: 'warning',
    IN_PROGRESS: 'primary',
    COMPLETED: 'success',
    IN_CLAIM: 'warning',
    CANCELLED: 'error',
    CANCELLATION_APPROVAL: 'error',
    CANCELLED_WITH_FAILED_ATTEMPT: 'error',
};
